import { render, staticRenderFns } from "./CardAgregarVotante.vue?vue&type=template&id=1fe41e45&scoped=true"
import script from "./CardAgregarVotante.vue?vue&type=script&lang=js"
export * from "./CardAgregarVotante.vue?vue&type=script&lang=js"
import style0 from "./CardAgregarVotante.vue?vue&type=style&index=0&id=1fe41e45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe41e45",
  null
  
)

export default component.exports